import React from "react";
import Head from "next/head";
import { GetServerSidePropsContext } from "next";
import styled from "styled-components";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Typography } from "@shared/ui/Typography";
import { Container } from "@shared/ui/sharedstyles";
import { Layout } from "@features/Layout";
import { useTranslation } from "next-i18next";
import ApplicationForm from "@entities/Product/Application";
import { axiosInstance } from "@shared/api";
import { IDictionaryApplicationResponse, IDir } from "@shared/types";

interface IProps {
  dictionaries: IDictionaryApplicationResponse;
  states: IDir[];
  brands: IDir[];
}

export default function ApplicationPage(props: IProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{t(`БНК Финанс Казахстан`)}</title>
      </Head>
      <StyledContent $size={928}>
        <StyledTitle tag="h1" weight={700} fontSize="3.2rem">
          {t(`Оформить заявку`)}
        </StyledTitle>
        <ApplicationForm
          dictionaries={props.dictionaries}
          states={props.states}
          brands={props.brands}
        />
      </StyledContent>
    </>
  );
}

ApplicationPage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const response = await axiosInstance.get("/dirs", {
    headers: { "Accept-Language": ctx.locale },
  });

  const statesResponse = await axiosInstance.get("/dir/cities", {
    headers: { "Accept-Language": ctx.locale },
  });

  const carBrandsResponse = await axiosInstance.get("/dir/brands", {
    headers: { "Accept-Language": ctx.locale },
  });

  return {
    props: {
      ...(await serverSideTranslations(ctx.locale, ["common"])),
      dictionaries: response.data,
      states: statesResponse.data,
      brands: carBrandsResponse.data,
    },
  };
}

const StyledContent = styled(Container)`
  padding-top: 6.4rem;
  padding-bottom: 8.4rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    padding-bottom: 6.4rem;
  }
`;

const StyledTitle = styled(Typography)`
  margin-bottom: 3.2rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    margin-bottom: 4.4rem;
  }
`;
